<script>
import UListViewGroup from 'cloud-ui.vusion/src/components/u-list-view.vue/group.vue';

export default {
    name: 'van-list-view-group',
    parentName: 'van-list-view',
    childName: 'van-list-view-item',
    extends: UListViewGroup,
}
</script>
